import { c as _c } from "react/compiler-runtime";
import React from "react";
const TimelineItemSkeleton = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-flex tw-flex-col tw-items-center"><div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-iron-700 tw-animate-pulse" /><div className="tw-w-0.5 tw-flex-1 tw-bg-iron-800 tw-mt-2" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-w-32 tw-h-4 tw-mb-3 tw-rounded-lg tw-bg-iron-800/80 tw-animate-pulse" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-iron-800/80 tw-animate-pulse" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-relative tw-flex tw-gap-4 tw-pb-8">{t0}<div className="tw-flex-1 tw-pb-4">{t1}<div className="tw-space-y-2"><div className="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl tw-bg-iron-900/50 tw-border tw-border-iron-800/40">{t2}<div className="tw-flex-1"><div className="tw-w-24 tw-h-3 tw-mb-2 tw-rounded tw-bg-iron-800/80 tw-animate-pulse" /><div className="tw-w-16 tw-h-3 tw-rounded tw-bg-iron-800/80 tw-animate-pulse" /></div></div></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export const WaveWinnersTimelineLoading: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-p-4"><TimelineItemSkeleton /><TimelineItemSkeleton /><TimelineItemSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};